export default __webpack_public_path__ + "static/media/image5.bdd428b3.png";